<!-- Banner (下载页banner)：2020/3/13 Sunanguang-->
<template>
  <div class="its-download-banner">
    <tabs :tabs="tabs" :selected-tab="selectedTab" @change-tab="changeTab"></tabs>
    <tab-items ref="tabItems" :tabs="tabs" @change-tab="tabChange"></tab-items>
  </div>
</template>
<script>
import TabItems from './TabItems'
import Tabs from './Tabs'
export default {
  name:'DownloadBanner',
  components: {
    Tabs,
    TabItems
  },
  props:{
    tabs: {
      type: Array,
      default: function () {
        return []
      }
    },
    height:{
      type:String,
      default:function(){
        return '775px'
      }
    },
    banners:{//banner列表
      type:Array,
      default:function(){
        return []
      }
    },
    carouselSet:{
      type:Object,
      default:function(){
        return {
          arrow:'never',//箭头显示
        }
      }
    }
  },
  data(){
      return {
        showIndicator:'outside',
        selectedTab: {}
      }
  },
  mounted(){
    if(this.banners.length==1){
      this.showIndicator = 'none'
    }
  },
  methods: {
    changeTab: function (tab) {
      this.selectedTab = JSON.parse(JSON.stringify(tab))
      this.$refs.tabItems.setActiveTab(tab.id - 1)
    },
    tabChange: function (index) {
      this.selectedTab = this.tabs[index]
    } 
  },
  watch: {
    $route: {
      handler: function () {
        let tabId = parseInt(this.$route.query.tab, 10)
        if (tabId) {
          setTimeout(() => {
            this.selectedTab = this.tabs[tabId - 1]
            this.$refs.tabItems.setActiveTab(tabId - 1)
          }, 200)
        } else {
          this.selectedTab = this.tabs[0]
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style scoped>
.its-download-banner {
  height: 774px;
  width: 100%;
  background-image: url(../../../../assets/images/download/download_bg.png);
  background-size: 100% 774px;
  background-repeat: no-repeat;
}
</style>
